import { useEffect } from 'react'

import { useSideSheet } from '@circlefin/side-sheet-router'
import { useRouter } from 'next/router'

export const SideSheetRouteListener: React.FC = () => {
  const router = useRouter()
  const sideSheet = useSideSheet()

  useEffect(() => {
    const handleSideSheetEvent = () => {
      void sideSheet.events.emit('onPageChange')
    }

    router.events.on('routeChangeStart', handleSideSheetEvent)

    return () => {
      router.events.off('routeChangeStart', handleSideSheetEvent)
    }
  }, [router.events, sideSheet.events])

  return null
}
